import React, { memo } from 'react';

import { Message } from '../Message';
import { useStyles } from './MessagesContainer.styles';
import { MessagesContainerProps } from './MessagesContainer.types';

export const MessagesContainer = memo(({ messages, onClose }: MessagesContainerProps) => {
  const styles = useStyles();

  return (
    <div className={`chhj-messages-container ${styles.container}`}>
      {messages.map(message => (
        <Message
          key={message.id}
          id={message.id}
          className={styles.message}
          onClose={() => onClose(message.id)}
          autoClose={message.autoClose}
          text={message.text}
          type={message.type}
        />
      ))}
    </div>
  );
});
